import React from "react";
import NestedFormBuilderDemo from "./NestedFormBuilderDemo";

function App() {
  return <NestedFormBuilderDemo />;
}

export default App;
